import { Injectable } from '@angular/core';
import { LocalStorageService } from '@shared/tools/local-storage.service';
import { TranslateService } from '@ngx-translate/core';
import { LANGUAGES, languages } from '@shared/i18n/languages';
import { LANGUAGE } from '@shared/tools/constants';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  constructor(
    private localStorageService: LocalStorageService,
    private translateService: TranslateService,
  ) {}

  currentLanguage(): string {
    return this.normalizeLanguage(
      this.localStorageService.getItem(LANGUAGE) || this.translateService.currentLang || LANGUAGES.PT_BR,
    );
  }

  getLanguages() {
    return languages;
  }

  setLanguage(newLanguage: string) {
    const normalizedLanguage = this.normalizeLanguage(newLanguage);
    this.translateService.use(normalizedLanguage);
    this.localStorageService.setItem(LANGUAGE, normalizedLanguage);
  }

  private normalizeLanguage(language: string | null | undefined): string {
    const normalized = String(language ?? '').trim().toLowerCase();

    if (normalized === 'pt' || normalized === 'pt-br' || normalized === 'pt_br') {
      return LANGUAGES.PT_BR;
    }

    if (normalized === 'en' || normalized === 'en-us' || normalized === 'en_us') {
      return LANGUAGES.EN_US;
    }

    return LANGUAGES.PT_BR;
  }
}
